import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import WebApp from "@twa-dev/sdk";
import api from '../api/axios';
import useUserStore from '../stores/userStore';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #23272f;
  color: #fff;
`;

const Logo = styled.div`
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 40px;
  color: #4b69ff;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 32px;
  width: 100%;
  max-width: 400px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #ccc;
  margin-bottom: 24px;
  text-align: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  font-size: 16px;
  margin-bottom: 16px;
  outline: none;
  transition: all 0.2s;

  &:focus {
    border-color: #4b69ff;
    box-shadow: 0 0 0 2px rgba(75, 105, 255, 0.2);
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: none;
  background: #4b69ff;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #3a56d4;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const SocialLinks = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const SocialButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const LoginView = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const setToken = useUserStore(state => state.setToken);
  const fetchUser = useUserStore(state => state.fetchUser);
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('token', token);
      setToken(token);
      localStorage.setItem('isAuthenticated', 'true');
      fetchUser();
      navigate('/', { replace: true });
    }
  }, [location, setToken, fetchUser, navigate]);

  useEffect(() => {
    if (localStorage.getItem('isAuthenticated') === 'true') {
      navigate('/', { replace: true }); // или другой защищённый путь
    }
  }, [navigate]);

  const handleLogin = async () => {
    if (password === 'skinforge25') {
      localStorage.setItem('isAuthenticated', 'true');
      // Убираем проверку соглашений - сразу считаем, что пользователь согласен
      localStorage.setItem('termsAccepted', 'true');
      navigate('/');
    } else {
      setError('Неверный пароль');
    }
  };

  const handleJoinTelegram = () => {
    const telegramLink = 'https://t.me/skinforge'; // Замените на вашу ссылку
    if (WebApp.isVersionAtLeast && WebApp.isVersionAtLeast('6.0')) {
      WebApp.openTelegramLink(telegramLink);
    } else {
      window.open(telegramLink, '_blank');
    }
  };

  return (
    <Container>
      <Logo>SkinForge</Logo>
      <Card>
        <Title>Приложение в разработке</Title>
        <Description>
          Мы работаем над созданием лучшего опыта для открытия кейсов.
          Скоро мы запустимся и вы сможете открывать кейсы с крутыми скинами!
        </Description>

        <Input
          type="password"
          placeholder="Введите пароль для доступа"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
        />
        {error && <Description style={{ color: '#ff4444' }}>{error}</Description>}

        <Button onClick={handleLogin}>
          Войти
        </Button>

        <SocialLinks>
          <Description>
            Подпишитесь на наше сообщество, чтобы быть в курсе новостей о запуске:
          </Description>
          <SocialButton onClick={handleJoinTelegram}>
            Присоединиться к Telegram
          </SocialButton>
        </SocialLinks>
      </Card>
    </Container>
  );
};

export default LoginView; 